import Vue from 'vue'

export const csBus = new Vue()
